import { render, staticRenderFns } from "./loginType.vue?vue&type=template&id=ecb4455c&"
import script from "./loginType.vue?vue&type=script&lang=ts&"
export * from "./loginType.vue?vue&type=script&lang=ts&"
import style0 from "./loginType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports